
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `1) 打開您的瀏覽器菜單`,
's182ab2d6c997515f': `將其加入主屏幕，以獲得更豐富的體驗和便捷訪問。`,
's1b9047d53d9f9d22': `2) 點擊列表上的分享按鈕`,
's2d90afa5dcca2c0e': `3) 向下滾動到「添加到主屏幕」`,
's37a9e8aec5713460': `詳細資訊`,
's4593f304dac8848c': `2) 點擊「添加到主屏幕」`,
's54cfbb14f46396d4': `1) 在您的主要瀏覽器中打開`,
's6196153c4b0c1ea0': `安裝`,
's922329d6f6213590': `添加到Dock欄`,
'sa5ef80b4bb9b39f8': `簡短資訊`,
'sa7551383d1897fcc': `2) 點選添加到Dock欄`,
'sba52286c21552a4e': `在您的裝置上安裝它，以獲得更豐富的體驗和便捷訪問。`,
'sc79fd7641eb9a975': `隱藏安裝流程`,
'scdaf4bbff76674c8': `將App加入主畫面`,
'se740f75b95a51807': `將其加入你的Dock欄，以獲得更豐富的體驗和便捷訪問。`,
'sfea652f6580ff086': `此網站具有應用程式功能。`,
    };
  